export default __webpack_public_path__ + "static/media/sign-in-bg.abd0b954.png";